exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pdf-container{position:relative;height:600px;overflow:hidden}.pdf-container #pdf-view{position:absolute;top:0;left:0;width:100%;border:0;height:100%;z-index:2}.pdf-container #pdf-view.hide-top-pane{top:-32px;height:calc(100% + 32px)}.upper-text input{text-transform:uppercase}", ""]);

